<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="text-danger" v-if="customer.hasError">
                    {{customer.errorMessage}}
                </div>
                <customer-select-for-order 
                        :orderTypeId="orderTypeId.value"
                        :clearSearch="clearCustomerSearch"
                        @customerSelected="onCustomerSelected"></customer-select-for-order>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="onModalCloseClick">Cancel</button>
            </div>
        </div>
    </div>
</div>